import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '../../core/services/menu.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu implements OnInit {
    menuService = inject(MenuService);
    model: any[] = [];

    async ngOnInit(): Promise<void> {
        var resp = await firstValueFrom(this.menuService.getMenusByRoleId());

        resp.menus.unshift({
            menuName: 'HOME',
            // menuIcon: 'pi pi-fw pi-home',
            details: [
                {
                    menuName: 'Dashboard',
                    menuIcon: 'pi pi-chart-pie',
                    menuUrl: '',
                }
            ]
        });
        resp.menus.forEach((menu) => {
            this.model.push({
                label: menu.menuName,
                // icon: menu.menuIcon,
                items: menu.details.map((detail) => {
                    return {
                        label: detail.menuName,
                        icon: detail.menuIcon,
                        routerLink: [detail.menuUrl]
                    };
                })
            });
            this.model.push({ separator: true });
        });
    }
}
